module.exports = __webpack_public_path__ + "img/Loading icon.c929df66.png";